export default {
  view_label: 'Ver {name}',
  title: 'Mapa',
  subtitle: 'Acompanhe a última localização dos seus dispositivos.',
  create_fence: 'Criar cerca',
  devices_on_map: 'dispositivo no mapa | dispositivos no mapa',
  aria_canvas: 'Mapa de dispositivos',
  unavailable: 'Mapa indisponível',
  loading: 'Carregando mapa...',
  type_aria: 'Tipo de mapa',
  type_map: 'Mapa',
  type_satellite: 'Satélite',
  satellite_disabled: 'Imagens de satélite não disponíveis no OpenStreetMap',
  expand: 'Expandir',
  collapse: 'Recolher',
  live: 'Ao vivo',
  reconnecting: 'Reconectando…',
  no_positions: 'Nenhum dispositivo com posição conhecida nos filtros atuais.',
  load_failed_map: 'Não foi possível carregar o mapa. Tente novamente.',
  tile_error: 'Não foi possível carregar parte do mapa. Verifique sua conexão.',
  fit_devices: 'Centralizar nos dispositivos',
  zoom_in: 'Aumentar zoom',
  zoom_out: 'Diminuir zoom',
  fence: {
    title_edit: 'Editar Cerca Eletrônica',
    title_new: 'Criar Cerca Eletrônica',
    subtitle: 'Desenhe no mapa e ajuste os detalhes aqui.',
    back: 'Voltar às cercas',
    shape_aria: 'Formato da cerca',
    shape_circle: 'Círculo',
    shape_polygon: 'Polígono',
    no_permission_create: 'Sua conta não tem permissão para criar cercas.',
    wait_map: 'Aguarde o mapa carregar para desenhar.',
    circle_hint: 'Clique no mapa para posicionar. Arraste o centro ou a borda para ajustar o círculo.',
    polygon_hint: 'Clique no mapa para marcar os pontos ({count}).',
    polygon_ready: 'Polígono pronto. Arraste os pontos para ajustar a área.',
    use_center: 'Usar centro do mapa',
    undo_point: 'Desfazer ponto',
    finish: 'Concluir desenho',
    redraw: 'Redesenhar',
    name: 'Nome da cerca',
    name_placeholder: 'Ex.: Casa, Escritório, Obra...',
    name_invalid: 'Informe um nome com até 120 caracteres.',
    radius: 'Raio (metros)',
    radius_aria: 'Ajustar raio da cerca',
    radius_short: '{m} m',
    drag_center: 'Arrastar o centro da cerca',
    drag_vertex: 'Arrastar ponto {n} do polígono',
    radius_meters: '{m} metros',
    radius_invalid: 'Informe um raio entre 50 e 2.000 metros.',
    color: 'Cor da cerca',
    private_zone: 'Zona de privacidade',
    private_zone_hint: 'O aparelho não registra posições dentro desta área. Aplicado apenas a cercas circulares atribuídas ao aparelho.',
    min_points: 'Marque pelo menos três pontos que formem uma área.',
    polygon_incomplete: 'Marque pelo menos três pontos e conclua o desenho antes de salvar.',
    circle_incomplete: 'Posicione o círculo no mapa e informe um raio entre 50 e 2.000 metros.',
    save_changes: 'Salvar alterações',
    save: 'Salvar Cerca',
    back_devices: 'Voltar aos dispositivos',
    created: 'Cerca criada e exibida no mapa.',
    saved_reload: 'Cerca salva. Recarregue a página para atualizar o mapa.',
    no_permission_edit: 'Você não tem permissão para editar esta cerca.',
    no_permission_manage: 'Você não tem permissão para gerenciar cercas nesta conta.',
    not_found: 'Cerca não encontrada ou indisponível nesta conta.',
    save_failed: 'Não foi possível salvar a cerca. Tente novamente.',
  },
  add_device: 'Adicionar',
  category_aria: 'Categoria do dispositivo',
  search_label: 'Buscar dispositivo',
  search_placeholder: 'Nome do dispositivo...',
  ordered_recent: 'Ordenado por detecção mais recente',
  ordered_name: 'Ordenado por nome',
  sort: 'Ordenar',
  sort_name: 'Nome A-Z',
  filters_aria: 'Filtros de dispositivos',
  loading_devices: 'Carregando dispositivos...',
  devices_load_failed: 'Não foi possível carregar os dispositivos.',
  retry_hint: 'Tente novamente em instantes.',
  no_devices: 'Nenhum dispositivo encontrado.',
  adjust_filters: 'Ajuste ou limpe os filtros.',
  activate_tag: 'Ativar tag',
  showing_count: 'Exibindo {shown} de {total} dispositivos',
  all_devices: 'Ver todos os dispositivos',
  alerts_recent: 'Alertas Recentes',
  alerts_period: 'Período (alertas)',
  period_24h: 'Últimas 24 horas',
  period_7d: 'Últimos 7 dias',
  period_30d: 'Últimos 30 dias',
  today_at: 'Hoje, {time}',
  marker: {
    accuracy: 'Precisão {m} m',
    battery: 'Bateria {pct}%',
  },
  my_location: 'Minha localização',
  you: 'Você',
  view_details: 'Ver detalhes',
  map_failed: 'Não foi possível carregar o mapa.',
}
